import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesDismissedQuery } from './UpdatesDismissed.query';

interface IUpdatesDismissed {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesDismissed = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesDismissed) => {
  return (
    <UpdatesDismissedQuery
      data={data}
      isLoading={isLoading}
      isError={isError}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesDismissed };
